module.exports = __webpack_public_path__ + "img/40_38_077_970.c77de3a0.jpg";